module.exports = __webpack_public_path__ + "img/tietle.14d07836.png";